import React, { useState } from 'react'
import { Layout } from 'antd'


import SiderToolbar from './SiderToolbar'
import LivePreview from './LivePreview'

const { Sider } = Layout


const SiderAttrs = {
  collapsedWidth: 0,
  collapsible: true,
  theme: 'light',
  zeroWidthTriggerStyle: {
    top: '30px',
    right: '100%'
  },
  width: '50%',
  breakpoint: 'sm'
}
let collapsedSider = false;
export default React.memo((props) => {
  const [collapsed, setCollapsed] = useState(true)
  collapsedSider = collapsed
  const { value, isloading, uploadDoc, pageProps } = props
  return (
    <Sider
      {...SiderAttrs}
      collapsed={collapsed}
      onCollapse={() => {
        setCollapsed(!collapsed)
        collapsedSider = !collapsedSider
      }}
    >
      <SiderToolbar
        value={value}
        isloading={isloading}
        uploadDoc={uploadDoc}
        pageProps={pageProps}
      />
      <LivePreview value={value} />
    </Sider>
  )
}, (prevProps, nextProps) => {
  return collapsedSider
})
